module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/why-pict-0a4a84d104a2a11b8aa5a9d14f072258.jpg";